define('customPlugins/atnDomEvent',[
        'knockout', 'lodash', 'jquery'
    ],
    function(ko, _, $) {
        'use strict';
        
        ko.bindingHandlers.atnDomEvent = {
            init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
                var value = valueAccessor(),
                    valueObj = ko.utils.unwrapObservable(value);
                $(element).on(valueObj.event, function(e) {
                    var element = this,
                        domEvent = e;
                    _.defer(function() {
                        valueObj.listener.call(element, domEvent);
                    });
                });
            }
        };        
    });
